import dayjs from 'dayjs';
import { formatDecimal, formatInt } from '../../utils/numberFormat';

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${formatInt(bytes)} B`;
  if (bytes < 1024 * 1024) return `${formatDecimal(bytes / 1024, 0)} KB`;
  return `${formatDecimal(bytes / 1024 / 1024, 1)} MB`;
}

/** "14:05" today, "Mon 14:05" this week, "12 Sep 14:05" otherwise. */
export function formatMessageTime(iso: string, now: Date = new Date()): string {
  const d = dayjs(iso);
  const n = dayjs(now);
  if (d.isSame(n, 'day')) return d.format('HH:mm');
  if (n.diff(d, 'day') < 7) return d.format('ddd HH:mm');
  return d.format('DD MMM HH:mm');
}

/** "just now", "5m", "3h", "2d", then a date. */
export function formatRelative(iso: string, now: Date = new Date()): string {
  const diffMs = now.getTime() - new Date(iso).getTime();
  const min = Math.floor(diffMs / 60000);
  if (min < 1) return 'just now';
  if (min < 60) return `${min}m`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}h`;
  const day = Math.floor(hr / 24);
  if (day < 7) return `${day}d`;
  return dayjs(iso).format('DD MMM');
}
